import {
	getOrderPassengerPoints,
	stringifyPoint,
} from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";
import type { TFunction } from "i18next";

const cellProcessing = (item: Order.Model, t: TFunction): string => {
	const pointOnMap = t("point_on_map");
	const points = getOrderPassengerPoints(item);

	if (!points?.length) return "";

	return stringifyPoint(points.at(-1), "address", pointOnMap);
};

export default cellProcessing;
